import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        [theme.breakpoints.down("lg")]: {
            top: "-83vh",
            bottom: "0vh",
        },
        [theme.breakpoints.down("md")]: {
            top: "-83vh",
            bottom: "0vh",
        },
        [theme.breakpoints.down("sm")]: {
            top: "-83vh",     
            bottom: "0vh",  
        },
    },
    modal: {
        background: "rgba(245, 245, 245, 0.05)",
        backdropFilter: 'blur(32px)',
        borderRadius: "8px",
        padding: "20px",
        width: "90%",
        maxWidth: "400px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        [theme.breakpoints.down("sm")]: {

        },

    },
    header: {
        marginBottom: "20px"
    },
    title: {
        fontSize: "20px",
        fontWeight: 600,
        color: "rgba(245, 245, 245, 1)",
        margin: "0 0 10px 0",
        textAlign: 'center',
    },
    description: {
        color: "#666",
        fontSize: "14px",
        lineHeight: 1.5,
        margin: 0
    },
    footer: {
        display: "flex",
        justifyContent: "space-between",
        gap: "2vw",
        marginTop: "20px",
    },
    button: {
        width: '100%',
        padding: "8px 16px",
        borderRadius: "4px",
        fontSize: "14px",
        fontWeight: 700,
        cursor: "pointer",
        border: "none",
        transition: "background-color 0.2s",
    },
    cancelButton: {
        backgroundColor: "transparent",
        border: '2px solid #00BA6C',
        borderRadius: 5,
        color: "#00BA6C",
        "&:hover": {
            backgroundColor: "rgba(0, 186, 108, 0.3)"
        }
    },
    removeButton: {
        backgroundColor: "transparent",
        border: '2px solid #FF1C29',
        borderRadius: 5,
        color: "#FF1C29",
        "&:hover": {
            backgroundColor: "rgba(255, 28, 41, 0.3)"
        }
    }
}));